<nav class="fixed top-0 left-0 right-0 z-[9999] pointer-events-none" [ngClass]="{ hidden: isMobile }">
  <div class="relative">

    <div class="relative" [ngClass]="{ 
      'ml-[542px]': !isPersonalProfileRoute && isMenuExpanded, 
      'ml-[342px]': isPersonalProfileRoute || !isMenuExpanded 
    }" style="height: auto;">
      <div #navbarCard class="m-2 mt-1.5 rounded-xl border border-[var(--color-gray-200)] dark:border-[var(--color-dark-bg-tertiary)] bg-white dark:bg-[var(--color-dark-bg-primary)] shadow-sm dark:shadow-lg pointer-events-auto">
        <div class="px-3 sm:px-4 py-2 flex flex-wrap items-center gap-3 xl:flex-nowrap xl:gap-4 w-full">
          <!-- Left side: Agent card with icon, name and description -->
          <div class="flex items-center gap-3 flex-1 min-w-0 w-full lg:w-auto order-1">
            <!-- Agent icon/image -->
            <div class="flex-shrink-0">
              @if (getAgentCardIconConfig(getCurrentAgentName()); as iconConfig) {
                <div class="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0" [style.background-color]="iconConfig.iconBg">
                  <img 
                    [src]="iconConfig.iconPath" 
                    [alt]="getCurrentAgentName() || 'Agente'" 
                    class="w-5 h-5 object-contain"
                    (error)="onImageError($event)"
                    loading="eager"
                  >
                </div>
              } @else {
                <div class="w-8 h-8 rounded-lg flex items-center justify-center bg-[var(--color-brand-100)] dark:bg-[var(--color-dark-bg-secondary)] flex-shrink-0">
                  <fa-icon 
                    [icon]="getCurrentAgentIcon()" 
                    class="text-sm text-[var(--color-brand-500)] dark:text-[var(--color-brand-300)]">
                  </fa-icon>
                </div>
              }
            </div>
            
            <!-- Agent info -->
            <div class="flex flex-col min-w-0">
              <h2 class="text-sm font-semibold text-gray-900 dark:text-white truncate">
                {{ getCurrentAgentName() }}
              </h2>
              <p class="hidden lg:block text-xs text-[var(--color-gray-500)] dark:text-[var(--color-gray-400)] truncate">
                Gestión y optimización de finanzas con análisis en tiempo real
              </p>
            </div>
          </div>

          <!-- Center-Right: Active connections selector and status indicator -->
          <div
            class="flex items-center gap-2 flex-wrap w-full md:basis-full md:order-3 xl:basis-auto xl:w-auto xl:order-2 justify-center md:justify-center xl:justify-start"
            [ngClass]="isChatRoute ? 'lg:mr-4 xl:mr-6' : ''">
            <!-- Connection selector dropdown -->
            <div class="relative connection-dropdown-container" data-onboarding="chat-connections-selector-container">
              <button 
                type="button"
                class="flex min-w-0 max-w-full items-center gap-1.5 px-2.5 py-1 rounded-lg border border-[var(--color-gray-300)] dark:border-[var(--color-dark-bg-tertiary)] text-[11px] sm:text-xs font-medium text-[var(--color-text-400)] dark:text-[var(--color-gray-300)] bg-white dark:bg-[var(--color-dark-bg-secondary)] hover:bg-[var(--color-gray-50)] dark:hover:bg-[var(--color-dark-bg-tertiary)] transition-colors leading-tight"
                (click)="toggleConnectionDropdown(); $event.stopPropagation()"
                [attr.data-has-selected-connection]="hasSelectedConnection() ? 'true' : 'false'"
                data-onboarding="chat-connections-selector-trigger">
                @if (getSelectedConnection(); as selectedConnection) {
                  @if (selectedConnection.imageUrl) {
                    <img
                      [src]="selectedConnection.imageUrl"
                      [alt]="selectedConnection.name"
                      class="w-4 h-4 object-contain flex-shrink-0"
                      (error)="onImageError($event)"
                      loading="eager"
                    >
                  } @else {
                    <div class="w-4 h-4 flex items-center justify-center flex-shrink-0">
                      <fa-icon [icon]="selectedConnection.icon" class="text-xs"></fa-icon>
                    </div>
                  }
                }
                <span class="shrink-0">Conexiones</span>
                @if (getSelectedConnection(); as selectedConnection) {
                  <span class="hidden lg:inline min-w-0 max-w-[11rem] truncate text-[10px] font-semibold text-[var(--color-gray-500)] dark:text-[var(--color-gray-400)]">
                    · {{ selectedConnection.name }}
                  </span>
                }
                <fa-icon [icon]="faChevronRight" class="text-xs opacity-60 transition-transform duration-200" [style.transform]="showConnectionDropdown ? 'rotate(90deg)' : 'rotate(0)'"></fa-icon>
              </button>

              <!-- Dropdown menu -->
              @if (showConnectionDropdown) {
              <div
                class="fixed top-[60px] w-64 bg-white dark:bg-[var(--color-dark-bg-secondary)] rounded-lg shadow-xl border border-[var(--color-gray-200)] dark:border-[var(--color-dark-bg-tertiary)] py-1 z-[9999] connection-dropdown"
                [class.connection-dropdown--scrollable]="shouldShowConnectionDropdownScrollHint()"
                (scroll)="updateConnectionDropdownScrollHint($event)"
                data-onboarding="chat-connections-selector-menu">
                @if (getConnectionsConnected().length > 0) {
                  @for (connection of getConnectionsConnected(); track connection.id) {
                  <button
                    type="button"
                    [class]="'w-full min-w-0 overflow-hidden px-3 py-2.5 flex items-center gap-2 text-xs text-[var(--color-text-400)] dark:text-[var(--color-gray-300)] transition-colors rounded text-left ' + 
                    (isConnectionSelected(connection.id) 
                      ? 'bg-[var(--color-brand-50)] dark:bg-[var(--color-dark-bg-tertiary)] hover:bg-[var(--color-brand-100)] dark:hover:bg-[var(--color-dark-bg-tertiary)]' 
                      : 'hover:bg-[var(--color-gray-100)] dark:hover:bg-[var(--color-dark-bg-tertiary)]')"
                    (click)="toggleConnectionSelection(connection.id); $event.stopPropagation()">
                    @if (connection.imageUrl) {
                      <img 
                        [src]="connection.imageUrl" 
                        [alt]="connection.name" 
                        class="w-4 h-4 object-contain flex-shrink-0"
                        (error)="onImageError($event)"
                        loading="eager"
                      >
                    } @else {
                      <div class="w-4 h-4 flex items-center justify-center flex-shrink-0">
                        <fa-icon [icon]="connection.icon" class="text-xs"></fa-icon>
                      </div>
                    }
                    <span class="min-w-0 flex-1 truncate font-medium">{{ connection.name }}</span>
                    @if (isConnectionSelected(connection.id)) {
                      <span class="text-green-500 text-sm font-bold">✓</span>
                    }
                  </button>
                  }
                } @else {
                <div class="px-3 py-2 text-xs text-[var(--color-gray-400)] dark:text-[var(--color-gray-500)]">
                  Sin conexiones disponibles
                </div>
                }
              </div>
              }
            </div>

            <!-- Connection status indicator -->
            <div class="flex items-center gap-2 px-2.5 py-0.5 rounded-full" [class]="hasSelectedConnection() ? 'bg-green-50 dark:bg-green-900/20' : (companyContextEnabled ? 'bg-[var(--color-brand-400)]/10 dark:bg-[var(--color-brand-400)]/15' : 'bg-gray-50 dark:bg-gray-800/20')">
              <div [class]="'w-2 h-2 rounded-full flex-shrink-0 animate-pulse ' + (hasSelectedConnection() ? 'bg-green-500' : (companyContextEnabled ? 'bg-[var(--color-brand-400)]' : 'bg-gray-400'))"></div>
              <span class="text-[10px] sm:text-xs font-semibold text-[var(--color-text-400)] dark:text-[var(--color-gray-300)] whitespace-nowrap">
                @if (hasSelectedConnection()) {
                  <span class="hidden sm:inline">CONEXIÓN ACTIVA</span>
                  <span class="sm:hidden">CONEXIÓN</span>
                } @else if (companyContextEnabled) {
                  <span class="hidden sm:inline">MI EMPRESA ACTIVA</span>
                  <span class="sm:hidden">EMPRESA</span>
                } @else {
                  <span class="hidden sm:inline">SIN SELECCIÓN</span>
                  <span class="sm:hidden">SIN</span>
                }
              </span>
            </div>
          </div>

          <!-- Divider + indicadores de estado de chat -->
          <div class="flex items-center gap-3 w-full sm:w-auto sm:ml-auto order-2 xl:order-3">
            @if (hasProcessingChat) {
              <div
                class="flex items-center gap-1.5 px-2.5 py-0.5 rounded-full bg-amber-50 dark:bg-amber-900/30 border border-amber-200 dark:border-amber-700">
                <span class="w-2 h-2 rounded-full bg-amber-500 animate-pulse flex-shrink-0"></span>
                <span
                  class="text-[10px] font-semibold tracking-wide text-amber-800 dark:text-amber-200 uppercase whitespace-nowrap">
                  CHAT PROCESANDO
                </span>
              </div>
            }

            <app-profile-menu></app-profile-menu>
          </div>
        </div>

        @if (shouldShowDesktopConnectionCta()) {
          <div class="desktop-chat-header__cta">
            <p class="desktop-chat-header__cta-text">
              Para recibir respuestas basadas en tus datos reales, por favor activa y selecciona una conexión.
            </p>
            <button
              type="button"
              class="desktop-chat-header__cta-button"
              (click)="handleMobileConnectionCta(); $event.stopPropagation()"
            >
              {{ getMobileConnectionCtaActionLabel() }}
            </button>
          </div>
        }
      </div>
    </div>
  </div>
</nav>

<nav
  class="fixed left-0 right-0 z-[9998] pointer-events-none px-3"
  [ngClass]="{
    hidden: !shouldShowMobileChatHeader()
  }"
  style="top: 4.25rem;"
>
  <div
    #navbarCard
    class="mobile-chat-header pointer-events-auto rounded-2xl border border-[var(--color-gray-200)] dark:border-[var(--color-dark-bg-tertiary)] bg-white/95 dark:bg-[var(--color-dark-bg-primary)]/95 shadow-sm backdrop-blur-sm"
    [class.mobile-chat-header--collapsed]="isMobileChatHeaderCollapsed"
  >
    <div class="mobile-chat-header__summary flex items-start gap-3 p-3">
      <div class="flex-shrink-0">
        @if (getAgentCardIconConfig(getCurrentAgentName()); as iconConfig) {
          <div class="w-10 h-10 rounded-xl flex items-center justify-center" [style.background-color]="iconConfig.iconBg">
            <img
              [src]="iconConfig.iconPath"
              [alt]="getCurrentAgentName() || 'Agente'"
              class="w-5 h-5 object-contain"
              (error)="onImageError($event)"
              loading="eager"
            >
          </div>
        } @else {
          <div class="w-10 h-10 rounded-xl flex items-center justify-center bg-[var(--color-brand-100)] dark:bg-[var(--color-dark-bg-secondary)]">
            <fa-icon
              [icon]="getCurrentAgentIcon()"
              class="text-sm text-[var(--color-brand-500)] dark:text-[var(--color-brand-300)]"
            ></fa-icon>
          </div>
        }
      </div>

      <div class="min-w-0 flex-1">
        <h2 class="text-sm font-semibold text-gray-900 dark:text-white truncate">
          {{ getCurrentAgentName() }}
        </h2>
        <p class="text-[11px] leading-4 text-[var(--color-gray-500)] dark:text-[var(--color-gray-400)] truncate">
          Gestión y optimización de finanzas con análisis en tiempo real
        </p>
      </div>

      <button
        type="button"
        class="mobile-chat-header__collapse-button"
        [attr.aria-expanded]="!isMobileChatHeaderCollapsed"
        [attr.aria-label]="isMobileChatHeaderCollapsed ? 'Desplegar selector del chat' : 'Plegar selector del chat'"
        (click)="toggleMobileChatHeaderCollapsed($event)"
      >
        <fa-icon
          [icon]="isMobileChatHeaderCollapsed ? faAngleDown : faAngleUp"
          class="text-xs"
        ></fa-icon>
      </button>
    </div>

    @if (!isMobileChatHeaderCollapsed) {
    <div class="mobile-chat-header__details px-3 pb-3">
      <div class="mobile-chat-header__meta">
        <div class="relative connection-dropdown-container" data-onboarding="chat-connections-selector-container">
          <button
            type="button"
            class="mobile-chat-header__button"
            (click)="toggleConnectionDropdown(); $event.stopPropagation()"
            [attr.data-has-selected-connection]="hasSelectedConnection() ? 'true' : 'false'"
            data-onboarding="chat-connections-selector-trigger"
          >
            @if (getSelectedConnection(); as selectedConnection) {
              @if (selectedConnection.imageUrl) {
                <img
                  [src]="selectedConnection.imageUrl"
                  [alt]="selectedConnection.name"
                  class="w-4 h-4 object-contain flex-shrink-0"
                  (error)="onImageError($event)"
                  loading="eager"
                >
              } @else {
                <div class="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <fa-icon [icon]="selectedConnection.icon" class="text-xs"></fa-icon>
                </div>
              }
            }
            <span>Conexiones</span>
            @if (getSelectedConnection(); as selectedConnection) {
              <span class="mobile-chat-header__button-label">
                · {{ selectedConnection.name }}
              </span>
            }
            <fa-icon
              [icon]="faChevronRight"
              class="text-xs opacity-60 transition-transform duration-200"
              [style.transform]="showConnectionDropdown ? 'rotate(90deg)' : 'rotate(0)'"
            ></fa-icon>
          </button>

          @if (showConnectionDropdown) {
            <div
              class="mobile-chat-header__dropdown"
              [class.mobile-chat-header__dropdown--scrollable]="shouldShowConnectionDropdownScrollHint()"
              (scroll)="updateConnectionDropdownScrollHint($event)"
              data-onboarding="chat-connections-selector-menu">
              @if (getConnectionsConnected().length > 0) {
                @for (connection of getConnectionsConnected(); track connection.id) {
                  <button
                    type="button"
                    [class]="'mobile-chat-header__dropdown-item ' +
                    (isConnectionSelected(connection.id)
                      ? 'mobile-chat-header__dropdown-item--active'
                      : '')"
                    (click)="toggleConnectionSelection(connection.id); $event.stopPropagation()"
                  >
                    @if (connection.imageUrl) {
                      <img
                        [src]="connection.imageUrl"
                        [alt]="connection.name"
                        class="w-4 h-4 object-contain flex-shrink-0"
                        (error)="onImageError($event)"
                        loading="eager"
                      >
                    } @else {
                      <div class="w-4 h-4 flex items-center justify-center flex-shrink-0">
                        <fa-icon [icon]="connection.icon" class="text-xs"></fa-icon>
                      </div>
                    }
                    <span class="flex-1 font-medium truncate">{{ connection.name }}</span>
                    @if (isConnectionSelected(connection.id)) {
                      <span class="text-green-500 text-sm font-bold">✓</span>
                    }
                  </button>
                }
              } @else {
                <div class="px-3 py-2 text-xs text-[var(--color-gray-400)] dark:text-[var(--color-gray-500)]">
                  Sin conexiones disponibles
                </div>
              }
            </div>
          }
        </div>

        <div
          class="mobile-chat-header__status"
          [class]="hasSelectedConnection() ? 'bg-green-50 dark:bg-green-900/20' : (companyContextEnabled ? 'bg-[var(--color-brand-400)]/10 dark:bg-[var(--color-brand-400)]/15' : 'bg-gray-50 dark:bg-gray-800/20')"
        >
          <div [class]="'w-2 h-2 rounded-full flex-shrink-0 animate-pulse ' + (hasSelectedConnection() ? 'bg-green-500' : (companyContextEnabled ? 'bg-[var(--color-brand-400)]' : 'bg-gray-400'))"></div>
          <span class="text-[10px] font-semibold text-[var(--color-text-400)] dark:text-[var(--color-gray-300)] whitespace-nowrap">
            @if (hasSelectedConnection()) {
              <span class="mobile-chat-header__status-text-full">CONEXIÓN ACTIVA</span>
              <span class="mobile-chat-header__status-text-short">CONEXIÓN</span>
            } @else if (companyContextEnabled) {
              <span class="mobile-chat-header__status-text-full">MI EMPRESA ACTIVA</span>
              <span class="mobile-chat-header__status-text-short">EMPRESA</span>
            } @else {
              <span class="mobile-chat-header__status-text-full">SIN SELECCIÓN</span>
              <span class="mobile-chat-header__status-text-short">SIN</span>
            }
          </span>
        </div>
      </div>

      @if (shouldShowMobileConnectionCta()) {
        <div class="mobile-chat-header__cta">
          <p class="mobile-chat-header__cta-text">
            Para recibir respuestas basadas en tus datos reales, por favor activa y selecciona una conexión.
          </p>
          <button
            type="button"
            class="mobile-chat-header__cta-button"
            (click)="handleMobileConnectionCta(); $event.stopPropagation()"
          >
            {{ getMobileConnectionCtaActionLabel() }}
          </button>
        </div>
      }

      @if (hasProcessingChat) {
        <div class="mobile-chat-header__processing">
          <span class="w-2 h-2 rounded-full bg-amber-500 animate-pulse flex-shrink-0"></span>
          <span class="text-[10px] font-semibold tracking-wide text-amber-800 dark:text-amber-200 uppercase whitespace-nowrap">
            CHAT PROCESANDO
          </span>
        </div>
      }
    </div>
    }
  </div>
</nav>
